import React from "react";
import toast from "react-hot-toast";

/**
 * Modal-like quota exceeded alert rendered as a react-hot-toast custom toast.
 * Full viewport overlay so it stays visible when the page is scrolled.
 * Optional position: { top, left } + anchorPosition 'above' places the modal above that point (e.g. above the trigger button).
 */
const QuotaToast = ({ toastId, title, message, buttonText, onDismiss, position, anchorPosition }) => {
  const handleClose = () => {
    toast.dismiss(toastId);
    onDismiss?.();
  };

  const isAnchored = position && typeof position.top === "number" && typeof position.left === "number" && anchorPosition === "above";
  const overlayStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 2147483647,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
    padding: 16,
  };
  const modalStyle = isAnchored
    ? { maxWidth: 420, width: "100%", position: "fixed", left: position.left, top: position.top - 8, transform: "translate(-50%, -100%)" }
    : { maxWidth: 420, width: "100%" };

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="quota-alert-title"
      aria-describedby="quota-alert-message"
      className="quota-alert-overlay"
      style={overlayStyle}
      onClick={handleClose}
    >
      <div
        className="modal-content shadow"
        style={modalStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header border-bottom">
          <h5 id="quota-alert-title" className="modal-title fw-bold">
            {title}
          </h5>
        </div>
        <div id="quota-alert-message" className="modal-body">
          <p className="mb-0">{message}</p>
        </div>
        <div className="modal-footer border-top">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleClose}
          >
            {buttonText || "OK"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotaToast;
